const loadCss = function (link) {
  return new Promise(function (resolve, reject) {
    const linkEl = document.head.querySelector(`link[href*="${link}"]`)
    const cssLoaded = Boolean(linkEl.sheet)
    if (cssLoaded) {
      resolve(linkEl)
    }

    linkEl.addEventListener('error', reject)
    linkEl.addEventListener('abort', reject)
    linkEl.addEventListener('load', function () {
      resolve(linkEl)
    })
  })
}

const loadAllCss = function (links) {
  const loadScriptPromises = links.map(link => loadCss(link))
  return Promise.all(loadScriptPromises)
}

export { loadCss, loadAllCss }
